var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGroupSessionIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.6867 5.67967C11.64 5.67301 11.5934 5.67301 11.5467 5.67967C10.5134 5.64634 9.69336 4.79967 9.69336 3.75967C9.69336 2.69967 10.5534 1.83301 11.62 1.83301C12.68 1.83301 13.5467 2.69301 13.5467 3.75967C13.54 4.79967 12.72 5.64634 11.6867 5.67967Z",
    fill: "#279BE2"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.8597 10.3003C13.1131 10.8003 12.0664 10.9869 11.0997 10.8603C11.3531 10.3136 11.4864 9.70694 11.4931 9.06694C11.4931 8.40027 11.3464 7.76694 11.0664 7.2136C12.0531 7.08027 13.0997 7.26694 13.8531 7.76694C14.9064 8.46027 14.9064 9.60027 13.8597 10.3003Z",
    fill: "#279BE2"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M4.29376 5.67967C4.34043 5.67301 4.3871 5.67301 4.43376 5.67967C5.4671 5.64634 6.2871 4.79967 6.2871 3.75967C6.2871 2.69301 5.4271 1.83301 4.36043 1.83301C3.30043 1.83301 2.44043 2.69301 2.44043 3.75967C2.44043 4.79967 3.26043 5.64634 4.29376 5.67967Z",
    fill: "#279BE2"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M4.36675 9.06706C4.36675 9.71373 4.50675 10.3271 4.76008 10.8804C3.82008 10.9804 2.84008 10.7804 2.12008 10.3071C1.06674 9.60706 1.06674 8.46706 2.12008 7.76706C2.83341 7.28706 3.84008 7.09373 4.78675 7.20039C4.51341 7.76039 4.36675 8.39373 4.36675 9.06706Z",
    fill: "#279BE2"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M8.08019 11.08C8.02686 11.0733 7.96686 11.0733 7.90686 11.08C6.68019 11.04 5.7002 10.0333 5.7002 8.79333C5.70686 7.52667 6.72686 6.5 8.0002 6.5C9.26686 6.5 10.2935 7.52667 10.2935 8.79333C10.2869 10.0333 9.31353 11.04 8.08019 11.08Z",
    fill: "#279BE2"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M5.9132 12.4598C4.90654 13.1331 4.90654 14.2398 5.9132 14.9064C7.05987 15.6731 8.93987 15.6731 10.0865 14.9064C11.0932 14.2331 11.0932 13.1264 10.0865 12.4598C8.94654 11.6931 7.06654 11.6931 5.9132 12.4598Z",
    fill: "#279BE2"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroupSessionIcon);
export default __webpack_public_path__ + "static/media/group-session-icon.007ccc4f29906d0dc012a53c6846b23d.svg";
export { ForwardRef as ReactComponent };